import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import { useEffect, useState } from "react"
import { useStore } from "../../../contexts/store"
import { PodClass } from "../../../classes/Pod"
import { iReadingQuestion } from "../../../shared/src/types/Interaction"

import { getUserMessage, isAfterDeadline } from "../../Elements/ReadingQuestion"
import Deadline from "../../Elements/Deadline"
import Link from "../../Elements/Link"
import UserInfoAvatar from "../../Elements/UserInfoAvatar"

import { Box, Button, IconButton } from "@mui/material"
import UxIcon from "../../Elements/UxIcon"


const ReadingQuestionsPreview = ({pod}: {pod: PodClass}) => {
  const { t } = useTranslation()
  const { podStore, sessionStore, uiStore } = useStore()
  const deviceWidth = uiStore.deviceWidth
  const [readingQuestions, setReadingQuestions] = useState<iReadingQuestion[]>([])
  let openReadingQuestions = []

  useEffect(()=> {
    const allReadingQuestions = pod.getAllReadingQuestions()
    setReadingQuestions(allReadingQuestions)
  }, [pod, pod.getAllReadingQuestions])

  if (!sessionStore.session) return null
  const userId = sessionStore.session.user.userId

  // filter for open reading questions
  for(const readingQuestion of readingQuestions) {
    const thread = podStore.getThread(readingQuestion.interactionId)
    const hasUserMessage = thread ? getUserMessage(thread, userId) : false
    if(!hasUserMessage && !isAfterDeadline(readingQuestion)) {
      openReadingQuestions.push(readingQuestion)
    }
  }
  // only show first six
  openReadingQuestions = openReadingQuestions.slice(0,6)

  if(openReadingQuestions.length === 0) return (
    <Box sx={{
      display: "grid",
      fontSize: "17px",
      fontStyle: "italic",
      fontWeight: 300,
      justifyContent: "center",
      padding: "8px",
      margin: "30px"
    }}>
      {t('No open reading questions')}
    </Box>
  )

  return (
    <Box sx={{
      display: "grid",
      gap: "15px",
      margin: "15px 30px 30px 30px",
    }}>
      {openReadingQuestions.map(readingQuestion =>
        <Box key={readingQuestion.interactionId} sx={{
          alignItems: "center",
          display: "grid",
          gap: "10px",
          gridTemplateColumns: "max-content auto max-content",
          padding: "3px 0"
        }}>
            <UserInfoAvatar podId={pod.podId} userId={readingQuestion.userId} sx={{
            fontSize:"16px",
            height: "30px",
            width: "30px"
          }}/>
          <Box sx={{
            color: "textcolor.main",
            display: "grid",
            gridTemplateRows: "max-content max-content",
            paddingRight: "25px"
          }}>
            <Box sx={{
              fontSize: "17px",
              overflow: "hidden",
              paddingTop: "2px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}>
              {readingQuestion.label}
            </Box>
            <Deadline readingQuestion={readingQuestion} />
          </Box>
            <Link noDecoration={true} to={`/pod/${pod.podId}/pdf/${readingQuestion.anchor.nodeId}/question/${readingQuestion.interactionId}`}>
              {deviceWidth === "tiny" ?
                <IconButton color="primary">
                  <UxIcon id="reply" />
                </IconButton>
              :
                <Button size="small">{t('reply')}</Button>
              }
            </Link>
        </Box>
      )}
    </Box>
  )
}

export default observer(ReadingQuestionsPreview)
